/** @format */
import { ImageLoader } from 'next/legacy/image';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum ResponsiveLoaderType {
    CLOUDFLARE = 'cloudflare',
    CONTENTFUL = 'contentful',
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ResponsiveLoader = {
    loader: ImageLoader | undefined;
    isLoaderEnabled: boolean;
};
